import { styled } from '@zenchef/styled-system/jsx'
import { SystemProperties } from '@zenchef/styled-system/types'
import { observer } from 'mobx-react'
import { useContext } from 'react'

import Scrollable from '@/components/Scrollable'
import { useTranslation } from '@/utils/hooks'
import safelySetInnerHTML from '@/utils/safelySetInnerHTML'
import StoresContext from '@/utils/StoresContext'

interface GDPRTextProps {
  display?: SystemProperties['display']
  scrollable?: boolean
}

const GDPRText = observer(({ display, scrollable }: GDPRTextProps) => {
  const { appStore } = useContext(StoresContext)
  const { t } = useTranslation()
  return (
    <styled.div
      display={display}
      fontSize='11px'
      color='charcoal.500'
      textAlign='justify'
      lineHeight='1.3'
      maxHeight={scrollable ? '200px' : 'unset'}
      overflowY={scrollable ? 'scroll' : 'unset'}>
      <Scrollable fancyScrollbar={scrollable}>
        <span
          {...safelySetInnerHTML(
            t('footer_disclaimer_rgpd', {
              hyperlink: `/privacy_policy_short?rid=${appStore.state.restaurantId}&lang=${appStore.state.language}`,
              restaurantName: appStore.state.name
            })
          )}
        />
      </Scrollable>
    </styled.div>
  )
})

export default GDPRText
